import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { NFLLeagueProvider } from '@/contexts/NFLLeagueContext';
import NFLNav from '@/components/nfl/NFLNav';

// SAB-565 pt2 (review fix 1): the account-level wallet pages render under the app's
// REAL chrome — the same NFLNav top bar + mobile bottom nav every other page gets —
// not a bespoke wallet nav. The wallet pages are top-level routes (outside the NFL
// shell), so clicking a nav tab navigates INTO the shell at that tab. NFLNav needs
// NFLLeagueContext, which this shell provides (the wallet pages are league-independent
// but the nav's league switcher reads it — same pattern the shell uses).
function ShellInner({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const goTab = (tab: string) => {
    if (tab === 'wallet') { navigate('/wallet'); return; }
    navigate(`/nfl?tab=${encodeURIComponent(tab)}`);
  };
  return (
    <div className="min-h-screen bg-gradient-dark overflow-x-hidden overflow-y-auto w-full max-w-[100vw]">
      <NFLNav activeTab="wallet" onTabChange={goTab} />
      <main className="w-full pb-[calc(env(safe-area-inset-bottom)+80px)] sm:pb-6">{children}</main>
    </div>
  );
}

export default function WalletShell({ children }: { children: ReactNode }) {
  return (
    <NFLLeagueProvider>
      <ShellInner>{children}</ShellInner>
    </NFLLeagueProvider>
  );
}
